import { ISearchBranch } from '../types/BranchSearch';

export const getBranchSearch = (item?: ISearchBranch) => ({
  id: item?.id ?? 0,
  title: item?.title ?? '',
  city_id: item?.city_id ?? 0,
  location: item?.location ?? '',
  company_id: item?.company_id ?? 0,
  status: item?.status ?? false,
  adress: item?.adress ?? '',
  code: item?.code ?? 0,
  delivery: item?.delivery ?? false,
  wsconn: item?.wsconn ?? false,
  last_exchanged: item?.last_exchanged ?? '',
  is_iiko: item?.is_iiko ?? false,
});

export const searchBranchAdapter = (data?: ISearchBranch[]) =>
  data?.map(item => getBranchSearch(item)) ?? [];
